/**
 * Three dots — the mark every ⋯ menu in this app opens from.
 *
 * It was a private component in `features/end-coaching` while that was the only menu drawing one.
 * The builder's plan menu is the second, a page may not reach into a feature's internals, and a
 * second hand-drawn set of three circles is exactly the drift this file prevents: the pair would
 * have been at two radii on two viewboxes, which reads as two different marks at 16px.
 *
 * The caller states the size, through `className`. There is no default: the two menus that draw it
 * sit in bars of different heights, and a size baked in here would be one of them wrong.
 */
export function MoreGlyph({ className }: { readonly className?: string }) {
  return (
    <svg className={className} viewBox="0 0 16 16" fill="currentColor" aria-hidden focusable="false">
      <circle cx="3.5" cy="8" r="1.4" />
      <circle cx="8" cy="8" r="1.4" />
      <circle cx="12.5" cy="8" r="1.4" />
    </svg>
  );
}
